import { AsyncValidatorFn, ValidatorFn } from '@angular/forms';

export type IValidationsBuildResult = {
	validations: Record<string, ValidatorFn[]>;
	messages: Record<string, string>[];
};

export type IAsyncValidationsBuildResult = {
	validations: Record<string, AsyncValidatorFn[]>;
	messages: Record<string, string>[];
};
